import * as React from 'react'

interface Props {
  content: React.ReactNode
  onClick: () => void
  dataQa?: string
}

export const Toast = ({ onClick, content, dataQa = 'toast' }: Props) => (
  <div className="toast" onClick={onClick} data-qa={dataQa}>
    {content}
  </div>
)
